import { render, staticRenderFns } from "./TipDialog.vue?vue&type=template&id=48ab3a78&scoped=true"
import script from "./TipDialog.vue?vue&type=script&lang=js"
export * from "./TipDialog.vue?vue&type=script&lang=js"
import style0 from "./TipDialog.vue?vue&type=style&index=0&id=48ab3a78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab3a78",
  null
  
)

export default component.exports